<template>
  <!--  首页 -->
  <div class="">
    <HeaderTop />
    <MenuPage />
    <BannerPage />
    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("solutiontitle") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <CarouselPage />

    <div class="home-red">
      <div class="title-home-box">
        <div class="title-home-two">{{ $t("serviceprovider") }}</div>
        <div><i class="iconfont icon-hengtiao icon-two"></i></div>

        <div class="serviceprovider-main">
          {{ $t("homedec") }}
        </div>
        <div class="serviceprovider-main-two top50">
          <div class="serviceprovider-main-box">
            <div class="serviceprovider-box">
              <NumberCounter
                :label="$t('serviceprovidertitle.label1')"
                :targetNumber="8"
                :dec="$t('serviceprovidertitle.dec1')"
              />
            </div>
            <div class="serviceprovider-box">
              <NumberCounter
                :label="$t('serviceprovidertitle.label2')"
                :targetNumber="500"
                :dec="$t('serviceprovidertitle.dec2')"
              />
            </div>
            <div class="serviceprovider-box">
              <NumberCounter
                :label="$t('serviceprovidertitle.label3')"
                :targetNumber="100"
                :dec="$t('serviceprovidertitle.dec2')"
              />
            </div>
            <div class="serviceprovider-box">
              <NumberCounter
                :label="$t('serviceprovidertitle.label4')"
                :targetNumber="30"
                :dec="$t('serviceprovidertitle.dec2')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-home-main top100">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("producttitle") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <ProductPage />

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("cooperativetitle") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <PartnerLogos />
    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerPage from "@/components/BannerPage.vue";
import CarouselPage from "../components/CarouselPage.vue";
import NumberCounter from "../components/NumberCounter.vue";
import ProductPage from "@/components/ProductPage.vue";
import PartnerLogos from "@/components/PartnerLogos.vue";

export default {
  components: {
    HeaderTop,
    MenuPage,
    BannerPage,
    CarouselPage,
    NumberCounter,
    ProductPage,
    PartnerLogos,
  },
  name: "HomePage",
  data() {
    return {};
  },
};
</script>
<style scoped>
.title-home-two {
  float: left;
  width: 100%;
  text-align: center;
  padding: 60px 0 0 0;
  font-size: 34px;
  color: #fff;
}
.home-red {
  float: left;
  width: 100%;
  background: url("../assets/img/2.jpg") no-repeat top center #d22a23;
  background-size: cover;
}
.icon-two {
  color: #fff;
}
.serviceprovider-main {
  float: left;
  width: 100%;
  color: #fff;
  padding: 50px 100px 0 100px;
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
  text-indent: 2em; /* 首行缩进两个字符 */
  word-wrap: break-word; /* 允许单词在必要时换行 */
  word-break: normal; /* 不切断英文字符 */
  overflow-wrap: break-word; /* 兼容性，与 word-wrap 相同 */
}
.top100 {
  padding-top: 100px;
}
.top50 {
  top: 50px;
}

@media (max-width: 1200px) {
  .top100 {
    padding-top: 70px;
  }
  .title-home-two {
    font-size: 24px;
  }
  .serviceprovider-main {
    float: left;
    width: 100%;
    padding: 50px 50px 0 50px;
  }
 
}
</style>
